import React, { Component } from "react";
//import PropTypes from 'prop-types'
import moment from "moment";
import "moment/locale/nl";
import "moment/locale/en-gb";
import "moment/locale/de";

import Icon from "../../Common/Icon";

export default class DateTimePickerInput extends Component {
  constructor(props) {
    super(props);
    this.input = React.createRef();
    this.hiddenInput = React.createRef();
    this.state = {
      rawValue: undefined,
    };
  }

  getFormattedDisplayValue() {
    let { locale, value, valueFormat, displayFormat } = this.props;
    if (!value) return "";

    moment.locale(locale || "en-gb");
    const momentValue = moment(value, valueFormat, true);
    return momentValue && momentValue.isValid()
      ? momentValue.format(displayFormat)
      : "";
  }

  getInputValue() {
    let { locale, valueFormat, inputFormat } = this.props;

    moment.locale(locale);
    const rawValue = this.input.current.value;
    const momentValue = moment(rawValue, inputFormat, false);
    const value =
      momentValue && momentValue.isValid()
        ? momentValue.format(valueFormat)
        : "";
    return value;
  }

  render() {
    const { rawValue } = this.state;
    let {
      container,
      datetimepicker,
      className,
      hasIndicator,
      inputFormat,
      valueFormat,
      displayFormat,
      value,
      inputIsReadOnly,
      disabled,
      label,
      name,
      locale,
      onChangeRaw,
      minDate,
      maxDate,
      invalidDate,
      ...inputProps
    } = this.props;

    moment.locale(locale || "en-gb");

    if (!inputIsReadOnly) {
      //Enable left and right arrow keys
      inputProps.onKeyDown = (e) => {
        if (e.keyCode === 37 || e.keyCode === 39) return;
        this.props.onKeyDown(e);
      };
    }

    label = label || name;

    //Enable text editing when in focus
    const displayValue =
      rawValue !== undefined
        ? rawValue
        : value
        ? this.getFormattedDisplayValue()
        : "";

    return (
      <div className="react-datepicker__input-container">
        <input
          ref={this.hiddenInput}
          type="hidden"
          name={name}
          value={value || ""}
        />
        <input
          {...inputProps}
          aria-label={label}
          ref={this.input}
          type="text"
          className={`${className} react-datepicker__input`}
          value={displayValue}
          autoComplete="off"
          readOnly={inputIsReadOnly}
          disabled={disabled}
          aria-required={!!this.props["aria-required"]}
          maxLength={
            rawValue === undefined ? displayValue.length : inputFormat.length
          }
          onFocus={(e) => {
            e.target = this.hiddenInput.current;
            e.target.value = this.input.current.value;

            this.setState({
              rawValue: value
                ? moment(value, valueFormat, true).format(inputFormat) || ""
                : "",
            });

            inputProps.onFocus(e);
          }}
          onBlur={(e) => {
            e.target = this.hiddenInput.current;
            e.target.value = this.input.current.value;

            inputProps.onBlur(e);
            setTimeout(() => {
              this.setState({
                rawValue: undefined,
              });
            }, 100);

            //Workaround: Triggered when Android tab is fired but won't close the datepicker automatically
            if (e.relatedTarget && !container.current.contains(e.relatedTarget))
              datetimepicker.current.handleCalendarClickOutside(e);

            const momentValue = moment(e.target.value, valueFormat);
            const travelDateLabel = document.getElementById("TravelDate");

            if (travelDateLabel) {
              if (
                momentValue.isSameOrAfter(minDate) &&
                momentValue.isSameOrBefore(maxDate)
              ) {
                travelDateLabel.innerText = momentValue.format(displayFormat);
              }
              if (
                !momentValue._isValid ||
                momentValue.isBefore(minDate) ||
                momentValue.isAfter(maxDate)
              ) {
                travelDateLabel.innerHTML = invalidDate;
                travelDateLabel.innerText = invalidDate;
              }
            }
          }}
          onChange={(e) => {
            const rawValue = e.currentTarget.value;
            this.setState({
              rawValue: rawValue,
            });

            if (this.onChangeTimeout) clearTimeout(this.onChangeTimeout);

            e.persist();
            this.onChangeTimeout = setTimeout(() => {
              this.onChangeTimeout = null;

              e.target = this.hiddenInput.current;
              e.target.value = this.getInputValue();

              onChangeRaw(e);
            }, 100);
          }}
        />
        {hasIndicator ? (
          <span
            className={`react-datepicker__indicator
                 react-datepicker__indicator--${
                   datetimepicker.current && datetimepicker.current.state.open
                     ? "open"
                     : "closed"
                 }`}
          >
            {datetimepicker.current && datetimepicker.current.state.open ? (
              <Icon
                className="react-datepicker__indicator-icon"
                iconName="chevron-up"
              />
            ) : (
              <Icon
                className="react-datepicker__indicator-icon"
                iconName="chevron-down"
              />
            )}
          </span>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Common/DateTimePickerInput.js